/* import __COLOCATED_TEMPLATE__ from './agent-type-icon.hbs'; */
/* RESPONSIBLE TEAM: team-automation-foundations */
import Component from '@glimmer/component';
//@ts-ignore
import { sanitizeHtml } from '@intercom/pulse/lib/sanitize';
import { AGENT_TYPE_CONFIG, DEFAULT_AGENT_TYPE } from 'embercom/lib/ai-agent/agent-type-config';
import type { AgentTypeValue } from 'embercom/lib/ai-agent/agent-type-config';

interface Arguments {
  agentType?: string;
  size?: 'small';
}

interface Signature {
  Element: HTMLDivElement;
  Args: Arguments;
}

export default class AgentTypeIcon extends Component<Signature> {
  get config() {
    let agentType = (this.args.agentType ?? DEFAULT_AGENT_TYPE) as AgentTypeValue;
    return AGENT_TYPE_CONFIG[agentType] ?? AGENT_TYPE_CONFIG[DEFAULT_AGENT_TYPE];
  }

  get iconName() {
    return this.config.icon;
  }

  get containerClasses() {
    let shapeAndSize =
      this.args.size === 'small' ? 'w-6 h-6 rounded-small' : 'w-5 h-5 rounded-full';
    return `inline-flex items-center justify-center ${shapeAndSize} ${this.config.containerClasses}`;
  }

  get outlineStyle(): string | undefined {
    if (this.args.size === 'small') {
      return undefined;
    }
    return sanitizeHtml('outline: 3px solid var(--base-module)');
  }

  get iconScale(): string | undefined {
    if (this.args.size === 'small') {
      return undefined;
    }
    return sanitizeHtml('transform: scale(0.75)');
  }
}

declare module '@glint/environment-ember-loose/registry' {
  export default interface Registry {
    'AiAgent::AgentTypeIcon': typeof AgentTypeIcon;
    'ai-agent/agent-type-icon': typeof AgentTypeIcon;
  }
}
